/* S&R growth attribution v1. Captures a tagged Meta visit in a private cart attribute.
 * Standard cart-to-COD and native CSV verified on 22 October 2026.
 */
(() => {
  'use strict';
  if (window.__srGrowthAttributionV1) return;
  window.__srGrowthAttributionV1 = true;
  const KEY = '__sr_growth_v1';
  const params = new URLSearchParams(window.location.search);
  // Visible only when explicitly requested during preview QA. No customer data.
  const debug = params.get('sr_growth_debug') === '1';
  function status(message) {
    if (!debug || !document.body) return;
    let box=document.getElementById('sr-growth-preview-check');
    if (!box) {
      box=document.createElement('aside');box.id='sr-growth-preview-check';
      box.style.cssText='position:fixed;top:90px;right:12px;z-index:10000;max-width:290px;padding:14px;background:#fff;color:#173d37;border:2px solid #294e3c;border-radius:8px;font:13px/1.5 Arial,sans-serif;box-shadow:0 2px 12px #0002';
      document.body.appendChild(box);
    }
    box.textContent='Attribution preview check: '+message;
    if (lastSent) {
      const clearButton=document.createElement('button');
      clearButton.type='button';clearButton.textContent='Clear test tracking';
      clearButton.style.cssText='display:block;margin-top:10px;padding:6px;cursor:pointer';
      clearButton.addEventListener('click',()=>updateCart(''));
      box.appendChild(clearButton);
    }
  }
  const fields = {
    source: params.get('utm_source'), medium: params.get('utm_medium'),
    campaign: params.get('utm_campaign'), creative_id: params.get('utm_content'),
    ad_id: params.get('utm_term') || '', campaign_id: params.get('utm_id') || ''
  };
  const sources = ['meta', 'facebook', 'instagram', 'fb', 'ig'];
  const code = /^[A-Za-z0-9_-]{1,80}$/;
  const numericId = /^\d{5,30}$/;
  const uniqueParams = ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','utm_id']
    .every(name => params.getAll(name).length <= 1);
  // Only our documented Meta-link convention is supported. Never store arbitrary URLs,
  // click IDs, referrers, contact details, cookies or customer identifiers.
  const valid = uniqueParams && sources.includes(fields.source) && fields.medium === 'paid_social'
    && code.test(fields.campaign || '') && code.test(fields.creative_id || '')
    && (!fields.ad_id || numericId.test(fields.ad_id))
    && (!fields.campaign_id || numericId.test(fields.campaign_id));
  let lastSent = null;
  let queue = Promise.resolve();
  const value = valid ? 'SRG1.' + btoa(JSON.stringify({v:1,...fields,
    captured_at:new Date().toISOString()})).replace(/\+/g,'-').replace(/\//g,'_').replace(/=+$/,'') + '.END' : null;

  function allowed() {
    const privacy = window.Shopify?.customerPrivacy;
    return privacy && typeof privacy.analyticsProcessingAllowed === 'function'
      && typeof privacy.marketingAllowed === 'function' && privacy.analyticsProcessingAllowed() === true
      && privacy.marketingAllowed() === true;
  }
  function updateCart(content) {
    const root = window.Shopify?.routes?.root;
    if (!root || !root.startsWith('/') || root.startsWith('//')) return;
    queue = queue.then(async () => {
      if (content && !allowed()) return;
      if (content === lastSent) return;
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 1500);
      try {
        const response = await fetch(root + 'cart/update.js', {
          method:'POST', credentials:'same-origin', signal:controller.signal,
          headers:{'Content-Type':'application/json'},
          body:JSON.stringify({attributes:{[KEY]:content}})
        });
        if (response.ok) {
          lastSent = content;
          status(content ? 'Shopify accepted the cart tracking update. Campaign: '+fields.campaign+'; creative: '+fields.creative_id+'; ad: '+(fields.ad_id || 'not supplied')+'. Order/export still needs testing.' : 'Tracking field cleared.');
        } else status('Cart update was not accepted. Attribution remains unverified.');
      } catch (_) {
        status('Cart update unavailable. Checkout is not blocked.');
        // Tracking is best effort. Never block or redirect the customer's checkout.
      } finally { clearTimeout(timer); }
    }).catch(() => {});
  }
  function sync() {
    const privacy = window.Shopify?.customerPrivacy;
    if (!privacy) return;
    if (allowed()) { if (value) updateCart(value); }
    else updateCart(''); // Clear only our field when processing is disallowed.
  }
  document.addEventListener('visitorConsentCollected', sync);
  function start() {
    status(valid ? 'Checking processing permissions.' : 'No valid tagged Meta visit on this page.');
    if (window.Shopify?.customerPrivacy) sync();
    else if (window.Shopify?.loadFeatures) {
      window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.2'}], error => {
        if (!error) sync(); else status('Privacy API unavailable; tracking skipped.');
      });
    } else status('Privacy API unavailable; tracking skipped.');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
})();
